import {useState, useEffect, useRef} from "react";
import {useDataApi, API} from "../components/API/index";

export default () => {
    const [authParams, setAuthParams] = useState();

    const {data, isLoading, isError, doFetch} = useDataApi("");

    useEffect(() => {
        if (authParams) {
            doFetch(API.AUTH_TEAMSTATS, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(authParams)
            }, {ignoreCache: true});
        }
    }, [authParams]);

    const teamStatsLogin = (_params) => {
        setAuthParams(Object.assign({}, _params, {apiName: 'teamStats'}));
    };

    return {teamStatsLogin, tsData: data, isTsLoading: isLoading, isTsError: isError};
};
